import React from 'react';

import PropTypes from 'prop-types';

import { FormSection } from 'components/FormHelper/FormSection';
import { LabelCheckbox } from 'components/LabelCheckbox/LabelCheckbox';

import { getBaseUrl } from 'utils/UrlUtil';

import './CheckboxRow.sass';

export const CheckboxRow = ({
  name,
  id,
  value,
  label,
  title,
  onChange,
  documentLink,
  error,
  editedHighlight,
  disabled,
  hoverText,
}) => {
  let isEdited = false;

  if (editedHighlight) {
    isEdited = value === true;
  }

  return (
    <div className="checkbox-row">
      <FormSection subtitle={title}>
        <LabelCheckbox
          tooltipText={hoverText}
          disabled={disabled}
          isEdited={isEdited}
          error={error}
          id={id || name}
          name={name}
          value={value}
          onChange={onChange}
          label={
            <>
              {label}{' '}
              {documentLink && (
                <a className="download-item" href={getBaseUrl() + documentLink} download>
                  Link zu den Dateien
                </a>
              )}
            </>
          }
        />
      </FormSection>
    </div>
  );
};
CheckboxRow.defaultProps = {
  disabled: false,
};

CheckboxRow.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  value: PropTypes.bool.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  title: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  documentLink: PropTypes.string,
  error: PropTypes.bool,
  editedHighlight: PropTypes.bool,
  disabled: PropTypes.bool,
  hoverText: PropTypes.string,
};

CheckboxRow.defaultProps = {
  id: '',
  title: '',
  documentLink: '',
  error: false,
  editedHighlight: false,
  hoverText: '',
};
